import baseUrl from '../baseUrl';
import isTokenExpired from '../../helpers/isTokenExpired';

const ENDPOINT = `${baseUrl}/capsiMonteiroLobato`;

function checkToken() {
    const token = window.localStorage.getItem('token');

    if (token) {
        if (isTokenExpired(token)) {
          window.localStorage.clear();
          window.location.replace('/');

          return isTokenExpired(token);
        }
    }
}

export const capsiMonteiroLobatoService = {
    async getPaciente(id) {
        const data = await fetch(`${ENDPOINT}/${id}`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });

        const response = await data.json();

        return response;
    },

    async allPacientes(pageNumber = 1, limit = 50, filterBy = 'sequencial', orderBy = 'asc') {
            if (checkToken()) return;

            const data = await fetch(
                `${ENDPOINT}?page=${pageNumber}&limit=${limit}&filterBy=${filterBy}&orderBy=${orderBy}`, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                }
            );

            const response = await data.json();

            return response;
    },

    async pacientesTotais() {
            if (checkToken()) return;

            const data = await fetch(
                `${ENDPOINT}/totais`, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                }
            );

            const response = await data.json();

            return response;
    },

    async update(id, values) {
        const response = await fetch(`${ENDPOINT}/${id}`, {
            method: 'PUT',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(values)
          });

          const data = await response.json();
          return data;
    },

    async delete(id) {
        const response = await fetch(`${ENDPOINT}/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });

        return response;
    },

    async create(data) {
        const response = await fetch(ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(data)
        });

        return response;
    },
}
// TODO caps busca